export enum ProfileActions {
  PROFILE_RENDERED = 'PROFILE_RENDERED',
}

export const myProfileRendered = () => ({
  type: ProfileActions.PROFILE_RENDERED,
});
